import { useState, useEffect, useRef } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

import { API_URL, FB_ID } from "../constants";
import Footer from "../Footer";
import Header from "../Header";

import SportsBetting from "../components/IconsSvg/SportsBetting";
import googleLogo from "../assets/img/google.svg";
import facebookLogo from "../assets/img/facebook.svg";

const Auth = () => {
  const [isFbInitialized, setIsFbInitialized] = useState(false);

  const [message, setMessage] = useState("");

  //SIGN IN (CHECKED TERMS) ====================================

  const [isTermChecked, setTermChecked] = useState(false);

  //INPUT-PASSWORD ==============================================
  const [activeTab, setActiveTab] = useState("login");

  const singleRef = useRef(null); // For the single password input
  const groupRef = useRef(null); // For the group of password inputs
  const [singleVisible, setSingleVisible] = useState(false);
  const [groupVisible, setGroupVisible] = useState(false);

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)

  const [formIsValid, setFormIsValid] = useState(false);
  const passwordRef = useRef(null);
  const confirmpasswordRef = useRef(null);
  const emailRef = useRef(null);

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const toggleSingle = () => {
    const input = singleRef.current.querySelector("input");
    const isVisible = input.type === "text";
    input.type = isVisible ? "password" : "text";
    setSingleVisible(!isVisible);
  };

  const toggleGroup = () => {
    const inputs = groupRef.current.querySelectorAll("input.password-group");
    const isVisible = inputs[0]?.type === "text";

    inputs.forEach((input) => {
      input.type = isVisible ? "password" : "text";
    });

    setGroupVisible(!isVisible);
  };

  //INPUT-PASSWORD ==============================================

  const handleBaseLogin = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const username = form[0].value;
    const password = form[1].value;

    const data = {
      username: username,
      password: password,
    };

    axios
      .post(API_URL + "auth/base/login/", data)
      .then((res) => {
        localStorage.setItem("exp", res.data.exp);
        localStorage.setItem("userId", res.data.user.id);
        localStorage.setItem("username", res.data.user.username);
        localStorage.setItem("token", res.data.access_token);

        window.location.href = "/";
      })
      .catch((err) => {
        setMessage(err.response.data.message);
      });
  };

  const handleSignUp = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const username = form[0].value;
    const email = form[1].value;
    const password = form[2].value;

    const data = {
      username: username,
      email: email,
      password: password,
    };

    axios
      .post(API_URL + "auth/base/register/", data)
      .then(() => {
        setMessage("User account has been created. Please, login.");

        setTimeout(() => {
          window.location.href = "/auth";
          setMessage("");
        }, 5000);
      })
      .catch((err) => {
        if (err.response.data.username) {
          setMessage(err.response.data.username[0]);
        }
      });
  };

  const handleGoogleLogin = async (response) => {
    try {
      const res = await axios.post(API_URL + "auth/google/login/", {
        token: response.access_token,
      });
      localStorage.setItem("exp", res.data.exp);
      localStorage.setItem("userId", res.data.user.id);
      localStorage.setItem("username", res.data.user.username);
      localStorage.setItem("token", res.data.access_token);

      window.location.href = "/";
    } catch (err) {
      console.warn(err);
    }
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => handleGoogleLogin(tokenResponse),
  });

  const handleFacebookLogin = async (accessToken) => {
    try {
      const res = await axios.post(API_URL + "auth/facebook/login/", {
        token: accessToken,
      });
      localStorage.setItem("exp", res.data.exp);
      localStorage.setItem("userId", res.data.user.id);
      localStorage.setItem("username", res.data.user.username);
      localStorage.setItem("token", res.data.access_token);

      window.location.href = "/";
    } catch (err) {
      console.warn(err);
    }
  };

  const loginFacebook = () => {
    if (!isFbInitialized || !window.FB) {
      console.warn("Facebook SDK not initialized yet!");
      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse) {
          // console.log("Login successful", response);
          handleFacebookLogin(response.authResponse.accessToken);
        } else {
          // console.log("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "email,public_profile" }
    );
  };

  const loadFacebookSDK = async () => {
    if (window.FB) {
      setIsFbInitialized(true);
      return;
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FB_ID,
        cookie: true,
        xfbml: true,
        version: "v12.0",
      });
      // console.log("Facebook SDK initialized");
      setIsFbInitialized(true);
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.onerror = () => {
      console.error("Failed to load Facebook SDK");
    };
    document.body.appendChild(script);
  };

  const onTabClick = (e) => {
    const tab = e.currentTarget.dataset.tab;
    setActiveTab(tab);
  };

  useEffect(() => {
    loadFacebookSDK();
  }, []);

  const checkBoxTerms = (e) => {
    const isChecked = e.currentTarget.checked;
    setTermChecked(isChecked);
  };

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)
  const validateEmail = (e) => {
    const emailValue = emailRef.current.value;

    if (!emailRegex.test(emailValue)) {
      emailRef.current.classList.add("invalid");
      setFormIsValid(false);
    } else {
      emailRef.current.classList.remove("invaild");
      setFormIsValid(true);
    }
  };

  const passwordValidation = (passwordRef, confirmpasswordRef) => {
    var isValid = passwordRef.value === confirmpasswordRef.value;
    if (!isValid) {
      confirmpasswordRef.classList.add("invalid");
    } else {
      confirmpasswordRef.classList.remove("invalid");
    }
    return isValid;
  };

  const formValidation = () => {
    const validate = passwordValidation(
      passwordRef.current,
      confirmpasswordRef.current
    );
    setFormIsValid(validate);
  };

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)

  return (
    <div className="body auth-body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <div className="auth">
            <div className="container-full-page">
              <div className="auth-wrap">
                <div className="auth__image-wrap">
                  <SportsBetting />
                </div>
                <div className="auth__form">
                  <div className="auth-form__wrap">
                    <p className="auth-message">{message}</p>
                    <ul className="tabs-list">
                      <li
                        data-tab="login"
                        className={activeTab === "login" ? "active" : ""}
                        onClick={onTabClick}
                      >
                        Login
                      </li>
                      <li
                        data-tab="signUp"
                        className={activeTab === "signUp" ? "active" : ""}
                        onClick={onTabClick}
                      >
                        Sign Up
                      </li>
                    </ul>
                    <div
                      data-tab-content
                      id="login"
                      className={`tab-content ${
                        activeTab === "login" ? "" : "hidden"
                      }`}
                    >
                      <form
                        className="login-form form-styles"
                        onSubmit={handleBaseLogin}
                      >
                        <div className="form-input__wrap">
                          <input
                            type="text"
                            className="log-name"
                            name="logName"
                            id="logName"
                            placeholder="Username"
                            required
                          />
                        </div>

                        <div className="form-input__wrap" ref={singleRef}>
                          <div className="password-input">
                            <input
                              type="password"
                              className="passw input__password"
                              name="password"
                              id="password"
                              placeholder="Password"
                              autocomplete="current-password"
                              required
                            />
                            <span
                              className={`show-password-input ${
                                singleVisible ? "display-password" : ""
                              }`}
                              onClick={toggleSingle}
                            ></span>
                          </div>
                        </div>

                        <div className="checkbox__row-wrap">
                          <div className="custom-checkbox">
                            <input
                              type="checkbox"
                              name="checkBoxForm"
                              id="checkBoxForm"
                            />
                            <label for="checkBoxForm">Remember me</label>
                          </div>
                          <a href="#" className="form__link">
                            Forgot password?
                          </a>
                        </div>

                        <button type="submit" className="main-btn" name="logIn">
                          Login
                        </button>
                      </form>
                      <div className="auth__acc-wrap">
                        <p>OR LOGIN WITH</p>
                        <button onClick={() => loginGoogle()}>
                          <img src={googleLogo} alt="Google" />
                          <span className="red-text">Google</span>
                        </button>
                        <button onClick={() => loginFacebook()}>
                          <img src={facebookLogo} alt="facebook" />
                          <span className="blue-text">facebook</span>
                        </button>
                      </div>
                    </div>
                    <div
                      className={`tab-content ${
                        activeTab === "signUp" ? "" : "hidden"
                      }`}
                      data-tab-content
                      id="signUp"
                    >
                      <div className="auth__acc-wrap">
                        <p>CONTINUE WITH</p>
                        <button onClick={() => loginGoogle()}>
                          <img src={googleLogo} alt="Google" />
                          <span className="red-text">Google</span>
                        </button>
                        <button onClick={() => loginFacebook()}>
                          <img src={facebookLogo} alt="facebook" />
                          <span className="blue-text">facebook</span>
                        </button>
                        <p>OR</p>
                      </div>
                      <form
                        className="sign-in-form form-styles"
                        onSubmit={handleSignUp}
                      >
                        <div className="form-input__wrap">
                          <input
                            type="text"
                            className="log-name"
                            name="regName"
                            id="regName"
                            placeholder="Username"
                            required
                          />
                        </div>

                        <div className="form-input__wrap">
                          <input
                            type="email"
                            className="reg-email"
                            name="regEmail"
                            id="regEmail"
                            placeholder="Email"
                            required
                            ref={emailRef}
                            onBlur={validateEmail}
                          />
                        </div>

                        <div className="group-password-inputs" ref={groupRef}>
                          <div className="form-input__wrap">
                            <div className="password-input">
                              <input
                                type="password"
                                className="passw input__password password-group password-main"
                                name="regPassword"
                                id="regPassword"
                                placeholder="Password"
                                autocomplete="current-password"
                                ref={passwordRef}
                                onBlur={formValidation}
                                required
                              />
                              <span
                                className={`show-password-input ${
                                  groupVisible ? "display-password" : ""
                                }`}
                                onClick={toggleGroup}
                              ></span>
                            </div>
                          </div>

                          <div className="form-input__wrap">
                            <div className="password-input">
                              <input
                                type="password"
                                className="passw input__password password-group password-confirm"
                                name="regConfPassword"
                                id="regConfPassword"
                                ref={confirmpasswordRef}
                                onBlur={formValidation}
                                placeholder="Confirm Password"
                                autocomplete="current-password"
                                required
                              />
                              <span
                                className={`show-password-input ${
                                  groupVisible ? "display-password" : ""
                                }`}
                                onClick={toggleGroup}
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="checkBoxTerms"
                            id="checkBoxTerms"
                            onClick={checkBoxTerms}
                          />
                          <label for="checkBoxTerms">
                            I agree to the{" "}
                            <a href="/terms" className="form__link">
                              Terms
                            </a>{" "}
                            &{" "}
                            <a href="/privacy-policy" className="form__link">
                              Privacy Policy
                            </a>
                          </label>
                        </div>

                        {/* <div className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="checkBoxNews"
                            id="checkBoxNews"
                          />
                          <label for="checkBoxNews">
                            I want to receive newsletters
                          </label>
                        </div> */}

                        <button
                          type="submit"
                          id="signInBtn"
                          className="main-btn"
                          name="signInBtn"
                          disabled={!isTermChecked}
                        >
                          Continue with Email
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Auth;
